module.exports = __webpack_public_path__ + "1f06e0f466a9a34cf78be3d455e4896f.png";